import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, amountFormatOnly, checkNumberOnly, numberWithCommas, validNumberCheck, replaceCommas, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconButton
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsV3,
  updateTripStatus,
  updateTrip
} from "../../../store/actions/tripActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../css/inputs'
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS,
  TRIP_ACTIONS_FORM_LABELS,
  TRIP_ACTIONS_DWEB,
  TRIP_ACTIONS_DWEB_PARTY
} from "../../../store/constants";
import S3Uploader from '../s3Uploader/s3Uploader';
import CloseIcon from '@material-ui/icons/Close';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import { getSingleVendorLedgerData, GetPaymentConfig } from '../../../store/actions/homeActionCreator';
import { TRIP_FILTER_STATUS_MAPPING } from '../../../store/constants';
import { getTripStartDateFilterValues } from '../../../utils/utils';
import * as logger from "../../../logger";
import { trackDwebEvent } from '../../analytics'
import DriverSelect from '../../components/Driver/DriverSelect';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { addSinglePartyPayment } from '../../../store/actions/partiesActionCreator';

const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  close: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  dialogTitleV1: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiTypography-root': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  },
  fwBold: {
    fontWeight: 'bold'
  },
  divHeading: {
    color: '#9ea0a5'
  },
  diV1: {
    display: 'flex'
  },
  mlV1: {
    marginLeft: 16
  },
  switchLabel: {
    marginLeft: 0
  },
  switchControl: {
    marginTop: 16,
    marginBottom: 8
  },
  paper1: {
    borderRadius: 16
  },
  eventIcon: {
    color: 'grey'
  }
}));
const getNextTripStatus = (tripStatus) => {
  const statusList = ['STARTED', 'COMPLETED', 'POD_RECEIVED', 'POD_SUBMITTED', 'PAYMENT_RECEIVED'];
  const index = statusList.indexOf(tripStatus);
  if (index > -1 && index < statusList.length - 1) {
    return statusList[index + 1];
  }
  return null;
}
const TripTimelineActionDialog = (props) => {
  const formClasses = useStyles();
  const inputClasses = inputStyles();
  let submit
  const {
    user,
    onConfirm,
    classes,
    open,
    onClose,
    onSave,
    action,
    defaultSelected,
    defaultPerson,
    location,
    dispatchTripDetailsAction,
    dispatchUpdateTripStatus,
    fromSingleSupplierPage,
    tripData,
    dispatchGetSingleVendorLedger,
    dispatchPaymentConfig,
    vendorIdFromSupplier,
    dispatchUpdateTrip,
    settleOpeningBalance,
    openingBalanceData,
    dispatchAddPartyPayment,
    ...other
  } = props;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = fromSingleSupplierPage ? tripData : settleOpeningBalance?openingBalanceData:user.singleTripData ? user.singleTripData :{};
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && tripDetails && tripDetails.vehicle && tripDetails.vehicle.vendorId ? tripDetails.vehicle.vendorId : 0;
  let driverVal = tripDetails && tripDetails.driver && tripDetails.driver.id ? tripDetails.driver.id : null;
  let title = '';
  let dateFilterValues = getTripStartDateFilterValues();
  const getEventDate = (eventName) => {
    if (tripDetails && tripDetails.tripEvents) {
      if (eventName === 'Settled') {
        eventName = 'PAYMENT_RECEIVED'
      }
      eventName = eventName.replace(' ', '_');
      const event = tripDetails.tripEvents.filter((e) => {
        return (e["event"].toLowerCase() == eventName.toLowerCase())
      })[0]
      if (event && event["eventDate"]) {
        return new Date((Number(event["eventDate"]) * 1000));
      }
    }
    return null;
  }
  const [paymentReminders, setPaymentReminders] = React.useState([]);
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  useEffect(() => {
    dispatchPaymentConfig((response) => {
      setPaymentReminders(response.response.customer_payment_reminder_config)
      logger.log("Trip Timeline Action Dialog", "Get Payment config Successfull");
    },
      () => {
        logger.log("Trip Timeline Action Dialog", "Get Payment config Failed");
      })
    if (tripId && !fromSingleSupplierPage && tripId != 'openingBalance') {
      fetchTrip(tripId)
    }
  }, [dispatchTripDetailsAction]);

  useEffect(() => {

  }, [open]);

  const [dialogopen, setDialogOpen] = React.useState(open);
  const [tripPODS, setTripPODS] = React.useState(tripDetails.tripPods && tripDetails.tripPods.length > 0 ? tripDetails.tripPods : []);
  //add/Edit AdvancePayment
  const [check, setCheck] = React.useState(false);
  const [paymentAdvanceDate, setPaymentAdvanceDate] = React.useState(new Date());
  const [paymentAdvanceMode, setPaymentAdvanceMode] = React.useState('Cash');
  const [paymentAdvanceNotes, setPaymentAdvanceNotes] = React.useState(null);
  const [paymentAdvanceAmount, setPaymentAdvanceAmount] = React.useState(tripDetails.partyBalance ? numberWithCommas(tripDetails.partyBalance) : null);
  const [paymentAdvanceRefNum, setPaymentAdvanceRefNum] = React.useState(null);
  const [paymentAdvanceReceivedByDriver, setPaymentAdvanceReceivedByDriver] = React.useState(null);
  const [driverNameModalOpen, setDriverNameModalOpen] = React.useState(false);
  const [driverValue, setDriverValue] = React.useState(null);
  const handleDriverSelectClose = () => {
    setDriverNameModalOpen(false);
    setPaymentAdvanceReceivedByDriver(false);
    setCheck(true);
  };
  const handleDriverSelectOpen = () => {
    setDriverNameModalOpen(true);
    setCheck(false);
  };
  const handleDriverSelectConfirm = (response) => {
    if (response && response.id && !settleOpeningBalance) {
      setDriverValue(null);
      dispatchUpdateTrip(tripId, { driverId: response.id }, () => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          setCheck(false);
          fetchTrip(tripId);
          setDriverNameModalOpen(false);
        }
      }, () => {

      })
    }else if(settleOpeningBalance && response && response.id){
      setDriverValue(response && response.id)
    }else{

    }
  }
  const handlePOD = (file) => {
    var newPOD = [...tripPODS];
    newPOD.push({
      podLink: file,
    });
    setTripPODS(newPOD);
  };

  const handleCTADeletePOD = (index) => {
    var newPOD = [...tripPODS];
    newPOD.splice(index, 1);
    setTripPODS(newPOD);
  }
  const validate = values => {
    const errors = {};
    if (!values.date) {
      errors.date = 'Please Select a date';
    }
    if (tripStatus == 'POD_SUBMITTED') {
      if (!values.payment_mode) {
        errors.payment_mode = 'Please Select a Payment';
      }
    }
    if (tripStatus == 'STARTED') {
      if (values.endOdometerReading && !validNumberCheck(values.endOdometerReading)) {
        errors.endOdometerReading = 'Invalid End KMs Reading';
      }
    }
    return errors;
  };
  const handleFormSave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
  };
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    let newStatus = getNextTripStatus(tripStatus);
    let requestData = {
      status: newStatus
    };
    let date = Math.round((new Date(values.date).setHours(0, 0, 0, 0) / 1000));
    if (newStatus === 'COMPLETED') {
      requestData['tripCompletedDate'] = date;
      requestData['endOdometerReading'] = Number(replaceCommas(values.endOdometerReading));
    } else if (newStatus === 'POD_RECEIVED') {
      requestData['podReceivedDate'] = date;
      if (tripPODS && tripPODS.length > 0) {
        requestData['podImageS3Links'] = [];
        tripPODS.forEach(element => {
          if (element.podLink && !element.id) {
            requestData['podImageS3Links'].push(element.podLink);
          }
        });
      }
    } else if (newStatus === 'POD_SUBMITTED') {
      requestData['podSubmittedDate'] = date;
      requestData['isReminderEnabled'] = values.isReminderEnabled;
      if (values.isReminderEnabled && typeof values.remainder_value != 'undefined') {
        if (paymentReminders && paymentReminders[values.remainder_value] && paymentReminders[values.remainder_value].value && paymentReminders[values.remainder_value].value.count) {
          requestData['reminderDuration'] = paymentReminders[values.remainder_value].value.count;
        }
        if (paymentReminders && paymentReminders[values.remainder_value] && paymentReminders[values.remainder_value].value && paymentReminders[values.remainder_value].value.unit) {
          requestData['reminderDurationUnit'] = paymentReminders[values.remainder_value].value.unit;
        }
      }
    } else if (newStatus === 'PAYMENT_RECEIVED') {
      requestData['tripSettlementDate'] = date;
      requestData['payments'] = [{
        'amount': tripDetails.partyBalance,
        'description': values.notes,
        'paymentData': values.refNumber,
        'paymentDate': date,
        'paymentMode': values.payment_mode,
        'receivedByDriver': values.receivedByDriver ? values.receivedByDriver : false
      }];
    }
    if(settleOpeningBalance){
      let paymentData = {
        "amount":tripDetails.partyBalance,
        "paymentMode": values.payment_mode,
        "isAdvance":false,
        "paymentData":values.refNumber,
        "customerId":Number(tripDetails.partyId),
        "description":values.notes,
        "paymentDate":date,
        "receivedByDriver":values.receivedByDriver ? values.receivedByDriver : false,
        "tripsAttributed":[
          {
            "openingBalanceId":tripDetails.openingBalanceId,
            "attributionAmount":tripDetails.partyBalance
          }
        ]
      }
      if(values.receivedByDriver && driverValue){
        paymentData.driverId = driverValue;
      }
      dispatchAddPartyPayment(
        paymentData, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            sendSucces("Opening Balance Settled Successfully");
            handleClose();
          } else {
            //sendError(response && response.status && response.status && response.status.message?response.status.message:TRIP_ACTIONS_FORM_LABELS[tripStatus]['failure'])
          }
        },
        () => {
          //sendError(TRIP_ACTIONS_FORM_LABELS[tripStatus]['failure'])
        }
      )
    }else{
      dispatchUpdateTripStatus(
        tripDetails.id,
        requestData, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            trackDwebEvent("Dweb Trip Status Update", {
              trip_id: tripId,
              party_id: user.singleTripData.party && user.singleTripData.party.customerId,
              party_name: user.singleTripData.party && user.singleTripData.party.name,
              vehicle_id: user.singleTripData.vehicle && user.singleTripData.vehicle.id,
              vehicle_number: user.singleTripData.vehicle && user.singleTripData.vehicle.number,
              trip_status: user.singleTripData.status
            });
            sendSucces(TRIP_ACTIONS_FORM_LABELS[tripStatus]['suceess']);
            handleClose();
            if (fromSingleSupplierPage) {
              let vendorLedgerRequestData = {
                fleetOwnerId: user.userInfo.entityId,
                vendorId: vendorIdFromSupplier,
                status: TRIP_FILTER_STATUS_MAPPING["ACTIVE"],
                startDateRange: dateFilterValues["YEAR"]["startDateRange"]
              }

              dispatchGetSingleVendorLedger(vendorLedgerRequestData,
                () => {
                  logger.log("Single Supplier Trips tab Dweb", "Single Supplier Fetch Successfull");
                },
                () => {
                  logger.log("Single Supplier Trips tab Dweb", "Single Supplier Fetch Failed");
                }
              )
            }
          } else {
            //sendError(response && response.status && response.status && response.status.message?response.status.message:TRIP_ACTIONS_FORM_LABELS[tripStatus]['failure'])
          }
        },
        () => {
          //sendError(TRIP_ACTIONS_FORM_LABELS[tripStatus]['failure'])
        }
      )
    }

  };
  const getFormFields = (values) => {
    let commonFields = [];
    // commonFields.push({
    //   size: 12,
    //   visible: true,
    //   field: (
    //     <div>
    //       <DatePicker
    //         disableFuture
    //         name="date"
    //         margin="normal"
    //         variant="inline"
    //         inputVariant="outlined"
    //         size="small"
    //         format="dd-MM-yyyy"
    //         label={TRIP_ACTIONS_FORM_LABELS[tripStatus] && TRIP_ACTIONS_FORM_LABELS[tripStatus]['date'] ? TRIP_ACTIONS_FORM_LABELS[tripStatus]['date'] : ""}
    //         placeholder="Enter a Date"
    //         required={true}
    //         dateFunsUtils={DateFnsUtils}
    //       />
    //     </div>
    //   ),
    // });
    if (tripStatus == 'STARTED') {
      commonFields.push(
        {
          size: 12,
          visible: true,
          inline: false,
          field: (
            <>
              <div className={formClasses.diV1}>

                <div>
                  {/* <div className={formClasses.divHeading}>Trip End Date*</div> */}
                  <DatePicker
                    disableFuture
                    name="date"
                    margin="normal"
                    variant="inline"
                    minDate={tripDetails && tripDetails.startDate ? new Date(tripDetails.startDate) : null}
                    fullWidth={true}
                    inputVariant="outlined"
                    size="small"
                    format="dd-MM-yyyy"
                    label="Trip End Date"
                    placeholder="Select a End Date"
                    dateFunsUtils={DateFnsUtils}
                    required={true}
                    InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                  />
                </div>
                <div className={formClasses.mlV1}>
                  {/* <div className={formClasses.divHeading}>End KM Reading</div> */}
                  <TextField
                    label={"End KMs"}
                    placeholder={'End readings'}
                    name="endOdometerReading"
                    margin="normal"
                    InputProps={{
                      endAdornment: <InputAdornment position="start">KMs</InputAdornment>,
                    }
                    }
                    fullWidth={true}
                    variant="outlined"
                    size="small"
                    fieldProps={
                      {
                        parse: value => (value ? numberWithCommas(Number(replaceCommas(value))) : null),
                        //format:value => (value ? numberFormat(Number(value)) : "")
                      }
                    }
                    margin="normal"
                  />
                </div>
              </div>
            </>
          ),
        })
    }
    if (tripStatus == 'COMPLETED') {
      commonFields.push(
        {
          size: 12,
          visible: true,
          inline: false,
          field: (
            <>
              <div className={formClasses.divHeading}>POD Received On*</div>
              <DatePicker
                disableFuture
                name="date"
                margin="normal"
                variant="inline"
                fullWidth={true}
                minDate={getEventDate('COMPLETED') ? getEventDate('COMPLETED') : tripDetails && tripDetails.startDate ? new Date(tripDetails.startDate) : null}
                inputVariant="outlined"
                size="small"
                format="dd-MM-yyyy"
                label="Date"
                placeholder="Select Date"
                dateFunsUtils={DateFnsUtils}
                required={true}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              />
            </>
          ),
        },
        {
          size: 12,
          visible: true,
          inline: false,
          field: (
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              {tripPODS && tripPODS.length > 0 && <Grid item>
                <div className="S3Uploader-image-margin">
                  {tripPODS && tripPODS.map((podImage, index) => podImage && podImage.podLink ? (
                    <div className="S3Uploader-image-div">
                      <img className="S3Uploader-imagesrc" src={podImage.podLink} alt="fileUpload" />
                      {!podImage.id && <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleCTADeletePOD(index) }}></img>}
                    </div>
                  ) : null)}
                </div>
              </Grid>}
              <Grid item>
                <S3Uploader toggle={true} directoryName={"dweb-images/Trip/TripTimeline"} handleFile={handlePOD} />
              </Grid>
            </Grid>
          ),
        })
    }
    if (tripStatus == 'POD_RECEIVED') {
      commonFields = [
        {
          size: 12,
          visible: true,
          field: (
            <>
              <div className={formClasses.divHeading}>POD Submitted On*</div>
              <DatePicker
                disableFuture
                name="date"
                margin="normal"
                variant="inline"
                fullWidth={true}
                minDate={getEventDate('POD_RECEIVED') ? getEventDate('POD_RECEIVED') : tripDetails && tripDetails.startDate ? new Date(tripDetails.startDate) : null}
                inputVariant="outlined"
                size="small"
                format="dd-MM-yyyy"
                label="Date"
                placeholder="Select Date"
                dateFunsUtils={DateFnsUtils}
                required={true}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              />
            </>
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <>
              <div className={inputClasses.reminderInput}>
                <div>
                  <AddAlertIcon />
                </div>
                <div>
                  Payment Reminder After
                </div>
                <div className={inputClasses.selectDiv}>
                  {<Select
                    name="remainder_value"
                    variant="outlined"
                    //label={''}
                    notched
                    labelWidth={0}
                    placeholder={''}
                    formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelWidth: 0, className: inputClasses.reminderselect }}
                  >
                    {paymentReminders && paymentReminders.map((type, index) => {
                      return (<MenuItem key={index} value={index}>{type.display}</MenuItem>);
                    })}
                  </Select>}
                </div>
                <div style={{ marginLeft: 'auto' }}>
                  <Switches
                    size='small'
                    margin='normal'
                    formControlProps={{
                      className: formClasses.switchControl
                    }}
                    formGroupProps={{}}
                    formControlLabelProps={{
                      classes: {
                        root: formClasses.switchLabel
                      },
                      labelPlacement: 'start',
                    }}
                    name="isReminderEnabled"
                    data={{ label: '', value: true }}
                    label="" />
                </div>
              </div>
            </>
          ),
        },
      ]
    }
    if (tripStatus == 'POD_SUBMITTED') {
      let tripSettlementMode = values.payment_mode;
      commonFields = [
        {
          size: 12,
          visible: true,
          field: (
            <TextField
              label={'Settle Amount'}
              placeholder="Enter a Amount"
              name="amount"
              variant="outlined"
              onChange={(e) => { setPaymentAdvanceAmount(numberWithCommas(e.target.value)) }}
              size="small"
              fieldProps={
                {
                  //parse:normalizeAmount,
                  //format:value => (value ? numberFormat(Number(value)) : "")
                }
              }
              disabled={true}
              margin="normal"
              required={true}
            />

          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <Radios
              label="Payment Mode"
              required={true}
              name="payment_mode"
              formControlProps={{ margin: 'normal' }}
              onChange={(e) => { setPaymentAdvanceMode(e.target.value) }}
              radioGroupProps={{ row: true }}
              formControlLabelProps={{
                classes: {
                  root: inputClasses.formRadio
                }
              }}
              data={[
                { value: "Cash", label: "Cash" },
                { value: "Cheque", label: "Cheque" },
                { value: "UPI", label: "UPI" },
                { value: "Bank Transfer", label: "Bank Transfer" },
                { value: "Fuel", label: "Fuel" },
                { value: "Others", label: "Others" },
              ]}
            />
          ),
        },
        {
          size: 12,
          visible: ['Cheque', 'UPI', 'Bank Transfer'].includes(tripSettlementMode),
          field: (
            <TextField
              label={(tripSettlementMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
              placeholder={"Enter a " + (tripSettlementMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
              name="refNumber"
              variant="outlined"
              onChange={(e) => { setPaymentAdvanceRefNum(e.target.value) }}
              size="small"
              fieldProps={
                {

                }
              }
              margin="normal"
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <div>
              <DatePicker
                disableFuture
                name="date"
                margin="normal"
                variant="inline"
                inputVariant="outlined"
                size="small"
                minDate={getEventDate('POD_SUBMITTED') ? getEventDate('POD_SUBMITTED') : tripDetails && tripDetails.startDate ? new Date(tripDetails.startDate) : null}
                onChange={(date) => { setPaymentAdvanceDate(date) }}
                format="dd-MM-yyyy"
                label={TRIP_ACTIONS_FORM_LABELS[tripStatus]['date']}
                placeholder="Select a Date"
                required={true}
                dateFunsUtils={DateFnsUtils}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              />
            </div>
          ),
        },
        {
          size: 12,
          visible: !hiredTrip ? true : false,
          field: (<Switches
            size='small'
            margin='normal'
            formControlProps={{
              className: formClasses.switchControl
            }}
            formGroupProps={{}}
            formControlLabelProps={{
              classes: {
                root: formClasses.switchLabel
              },
              labelPlacement: 'start',
            }}
            onChange={(e, value) => {
              setPaymentAdvanceReceivedByDriver(value)
              if (value && value && !driverVal) {
                handleDriverSelectOpen(true);
              }
            }}
            name="receivedByDriver"
            data={{ label: 'Received By Driver', value: true }} label="" />)
        },
        {
          size: 12,
          visible: true,
          field: (
            <TextField
              label={'Notes'}
              placeholder="Enter Notes"
              name="notes"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={(e) => { setPaymentAdvanceNotes(e.target.value) }}
              multiline={true}
              rows={3}
              rowsMax={3}
              InputProps={{
                startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>
              }}
            />
          ),
        }
      ];
    }


    return commonFields;
  }
  let initialValues = {
    date: new Date()
  };
  if (tripStatus == 'POD_RECEIVED') {
    initialValues.remainder_value = 2
  }
  if (tripStatus == 'POD_SUBMITTED') {
    initialValues = {
      ...initialValues,
      payment_mode: paymentAdvanceMode,
      amount: paymentAdvanceAmount,
      date: paymentAdvanceDate,
      notes: paymentAdvanceNotes,
      refNumber: paymentAdvanceRefNum,
      receivedByDriver: paymentAdvanceReceivedByDriver
    }
  }
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"trip-timeline-actions-title-for-" + tripStatus ? tripStatus : ''}
        open={dialogopen}
        classes={{ paperScrollPaper: formClasses.paper1 }}
      >
        <DialogTitle id={"trip-actions-title-for-" + tripStatus ? tripStatus : ''} onClose={handleClose} className={formClasses.dialogTitleV1}>
          <div className={formClasses.fwBold}>{hiredTrip ? TRIP_ACTIONS_DWEB_PARTY[tripStatus] : settleOpeningBalance?"Settle Opening Balance":TRIP_ACTIONS_DWEB_PARTY[tripStatus]}</div>
          <IconButton
            edge="end"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon className={formClasses.close} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </DialogContent>
        <DialogActions style={{ paddingTop: 21, paddingBottom: 21, paddingRight: 24 }}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16, backgroundColor: 'white', color: 'black', textTransform: 'capitalize', borderRadius: 4, fontWeight: 300 }} >
            Close
          </Button>
          <Button variant="contained" className='modal-save-cta' onClick={event => submit(event)} style={{ color: 'white', backgroundColor: 'black', borderRadius: 4, textTransform: 'capitalize', fontWeight: 300 }}>
            {hiredTrip ? TRIP_ACTIONS_DWEB_PARTY[tripStatus] :settleOpeningBalance?"Settle Opening Balance":TRIP_ACTIONS_DWEB_PARTY[tripStatus]}
          </Button>
        </DialogActions>
      </Dialog>
      {driverNameModalOpen && <DriverSelect onOpen={driverNameModalOpen} onClose={handleDriverSelectClose} onConfirm={handleDriverSelectConfirm} />}
    </div >
  );
}
const TripTimelineActionDialogWithRouter = withRouter(TripTimelineActionDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchUpdateTripStatus: (tripId, data, onSuccess, onFailure) => { dispatch(updateTripStatus(tripId, data, onSuccess, onFailure)) },
  dispatchGetSingleVendorLedger: (data, onSuccess, onFailure) => {
    dispatch(getSingleVendorLedgerData(data, onSuccess, onFailure))
  },
  dispatchPaymentConfig: (onSuccess, onFailure) => {
    dispatch(GetPaymentConfig(onSuccess, onFailure))
  },
  dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
    dispatch(updateTrip(tripId, trip, onSuccess, onError));
  },
  dispatchAddPartyPayment: (data, onSuccess, onError) => {
      dispatch(addSinglePartyPayment(data, onSuccess, onError))
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripTimelineActionDialogWithRouter);